import { useEffect } from 'react';
import { visitorService } from '../services/api';

export const VisitorTracker = () => {
  useEffect(() => {
    // Log visitor on component mount
    const logVisitor = async () => {
      try {
        await visitorService.logVisit(window.location.pathname);
      } catch (error) {
        console.error('Failed to log visitor:', error);
      }
    };

    logVisitor();
  }, []);

  // This component doesn't render anything
  return null;
};
